import declinationOfNumber from '@/utils/declinationOfNumber';

export const WEATHER_SELECT = [
  { value: 'wind', text: 'Ветер' },
  { value: 'temperature', text: 'Температура' },
  { value: 'precipitation', text: 'Осадки' },
];

export const createDefaultCondition = (betweenCondition = undefined) => ({
  variable: '',
  condition: '',
  value: '',
  betweenCondition,
  minHours: '0',
  maxHours: '0',
  informers: [],
});

export const PERIOD_SELECT = [
  { value: '0', text: '0 часов' },
  { value: '1', text: '1 час' },
  { value: '3', text: '3 часа' },
  { value: '6', text: '6 часов' },
  { value: '12', text: '12 часов' },
  { value: '24', text: '24 часа' },
  { value: '48', text: '48 часов' },
  { value: '72', text: '72 часа' },
];

export const BETWEEN_CONDITIONS = {
  undefined: 'ЕСЛИ',
  AND: 'И',
  OR: 'ИЛИ',
  'AND()': 'И под скобками',
  'OR()': 'ИЛИ под скобками',
};

export const MONTHS_CONDITIONS = [
  { value: 1, text: 'Январь' },
  { value: 2, text: 'Февраль' },
  { value: 3, text: 'Март' },
  { value: 4, text: 'Апрель' },
  { value: 5, text: 'Май' },
  { value: 6, text: 'Июнь' },
  { value: 7, text: 'Июль' },
  { value: 8, text: 'Август' },
  { value: 9, text: 'Сентябрь' },
  { value: 10, text: 'Октябрь' },
  { value: 11, text: 'Ноябрь' },
  { value: 12, text: 'Декабрь' },
];

export const CONDITION_SELECT = [
  { value: '<', text: 'Меньше' },
  { value: '>', text: 'Больше' },
  { value: '=', text: 'Равно' },
  { value: '<=', text: 'Меньше или равно' },
  { value: '>=', text: 'Больше или равно' },
];

export const UNITS = {
  wind: '(м/c)',
  temperature: '(°C)',
  precipitation: '(мм/ч)',
  '': '',
};

export const MESSAGES = [
  'Очень сильный ветер, включая шквал',
  'Ураган',
  'Смерч',
  // 'Сильный ливень',
  // 'Очень сильный дождь',
  // 'Очень сильный снег',
  // 'Продолжительный сильный дождь',
  // 'Крупный град',
  // 'Сильная метель',
  // 'Сильный туман (сильная мгла)',
  // 'Сильное ГИО',
  'Сильный мороз',
  'Аномально-холодная погода',
  'Сильная жара',
  'Аномально-жаркая погода',
  'Чрезвычайная пожарная опасность',
  'Заморозки',
  // 'Переувлажнение почвы',
  // 'Засуха',
  // 'Засуха атмосферная',
  // 'Засуха почвенная',
  // 'Раннее появление или установление снежного покрова',
];

export const getConditionsFromString = (string) => {
  const conditions = [];

  const objectsLength = string.split('{').length - 1;

  if (objectsLength === 0) return false;

  for (let i = 0; i < objectsLength; i += 1) conditions.push(createDefaultCondition());

  let index = 0;

  const getBetweenCondition = (nextObjectIndex, isInBrackets) => {
    let betweenIndex = string.indexOf('AND', index);

    if (betweenIndex >= nextObjectIndex || betweenIndex === -1) {
      betweenIndex = string.indexOf('OR', index);

      if (betweenIndex >= nextObjectIndex || betweenIndex === -1) {
        console.error('Parsing error: betweenCondition not found');
      } else {
        return isInBrackets ? 'OR()' : 'OR';
      }
    } else {
      return isInBrackets ? 'AND()' : 'AND';
    }
  };

  for (let i = 0; i < objectsLength; i += 1) {
    index = string.indexOf('{', index);
    const nextObjectIndex = string.indexOf('{', index + 1);

    if (conditions[i + 1]) {
      if (index !== 0 && string[index - 1] === '(') {
        conditions[i + 1].betweenCondition = getBetweenCondition(nextObjectIndex, true);
      } else {
        conditions[i + 1].betweenCondition = getBetweenCondition(nextObjectIndex, false);
      }
    }

    const variableIndex = string.indexOf('}', index);
    conditions[i].variable = string.substring(index + 1, variableIndex);

    let hourPeriodIndex = string.indexOf('[', variableIndex);
    const hourPeriodIndex1 = string.indexOf(',', hourPeriodIndex);
    conditions[i].minHours = string.substring(hourPeriodIndex + 1, hourPeriodIndex1);
    hourPeriodIndex = string.indexOf('[', hourPeriodIndex + 1);
    conditions[i].maxHours = string.substring(hourPeriodIndex1 + 1, hourPeriodIndex - 1);

    const informersListIndex = string.indexOf(']', hourPeriodIndex);
    conditions[i].informers = string.substring(hourPeriodIndex + 1, informersListIndex)
      .split(',').map(__ => ({ id: __ }));

    const conditionIndex = string.indexOf(' ', informersListIndex + 3);
    conditions[i].condition = string.substring(informersListIndex + 2, conditionIndex).trim();

    const valueSpaceIndex = string.indexOf(' ', conditionIndex + 1);
    const valueBracketIndex = string.indexOf(')', conditionIndex);
    let valueIndex = (valueBracketIndex !== -1 && valueBracketIndex < valueSpaceIndex)
      ? valueBracketIndex : valueSpaceIndex;
    if (valueIndex === -1) valueIndex = string.length;
    conditions[i].value = string.substring(conditionIndex + 1, valueIndex);

    index += 1;
  }

  let months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  if (conditions[conditions.length - 1].variable === 'month') {
    conditions.pop();
    const monthIndex = string.indexOf('IN');
    months = string.substring(monthIndex + 4, string.indexOf(')', monthIndex)).split(',')
      .map(_ => parseInt(_, 10));
  }

  return { conditions, months };
};

export const getStringFromConditions = (conditions, months, humanString = false) => {
  let str = humanString ? 'ЕСЛИ ' : '';
  let endOfStr = '';

  conditions.forEach((_, i) => {
    try {
      let { variable } = _;

      if (humanString) {
        variable = WEATHER_SELECT.find(x => _.variable === x.value).text;
      }

      const next = conditions[i + 1];

      switch (_.betweenCondition) {
        case 'OR':
        case 'OR()':
          str += humanString ? ' ИЛИ ' : ' OR ';
          break;
        case 'AND':
        case 'AND()':
          str += humanString ? ' И ' : ' AND ';
          break;
        default:
          break;
      }

      const isInBrackets = (n) => n.betweenCondition === 'AND()' || n.betweenCondition === 'OR()';

      if (next) {
        if (isInBrackets(next)) str += '(';
      }

      let minHours = '';
      let maxHours = '';

      if (_.minHours) {
        minHours = `${_.minHours} ${declinationOfNumber(_.minHours, ['часа', 'часов', 'часов'])}`;
        minHours = `от ${minHours}`;
      }
      if (_.maxHours) {
        maxHours = `${_.maxHours} ${declinationOfNumber(_.maxHours, ['часа', 'часов', 'часов'])}`;
        if (_.minHours) maxHours = ` до ${maxHours}`;
        else maxHours = `до ${maxHours}`;
      }

      let hours = `${minHours}${maxHours}`;
      if (hours) {
        hours = `[${hours}`;
      }

      let nonHumanHours = `[${_.minHours ? _.minHours : '0'},${_.maxHours ? _.maxHours : '0'}`;

      if (_.informers) {
        nonHumanHours += `,[${_.informers.join(',')}]`;
        const iL = _.informers.length;
        hours += `, ${iL} ${declinationOfNumber(iL, ['информер', 'информера', 'информеров'])}`;
      }

      let hoursString = humanString ? hours : nonHumanHours;

      hoursString += ']';

      variable = humanString ? `'${variable}'` : `{${variable}}`;

      str += `${variable}${hoursString} ${_.condition} ${_.value}`;

      const closeCondition = () => {
        if (_.betweenCondition === 'AND()' || _.betweenCondition === 'OR()') str += ')';
      };

      if (next) {
        if (isInBrackets(next) && isInBrackets(_)) {
          endOfStr += ')';
        } else {
          str += endOfStr;
          endOfStr = '';
          closeCondition();
        }
      } else {
        str += endOfStr;
        endOfStr = '';
        closeCondition();
      }
    } catch (e) { /* pass */ }
  });

  if (months.length > 0 && months.length < 12) {
    if (humanString) {
      const m = months.map(_ => MONTHS_CONDITIONS.find(__ => __.value === _).text);

      str += ` И Месяц ОДИН ИЗ (${m})`;
    } else {
      str += ` AND {month} IN (${months})`;
    }
  }

  return str;
};

export default {
  BETWEEN_CONDITIONS,
  WEATHER_SELECT,
  MONTHS_CONDITIONS,
  CONDITION_SELECT,
  UNITS,
  MESSAGES,

  getStringFromConditions,
  getConditionsFromString,
  createDefaultCondition,
};
